module.exports = __webpack_public_path__ + "img/circle_in_progress.45728ed0.svg";